import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// 动态加载脚本的函数
function loadScript(url: string) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = 'avatar-anime-script';
    script.src = url;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// 按顺序加载所需的脚本
async function loadDependencies(url: string) {
  const scripts = [url];

  for (const script of scripts) {
    await loadScript(script);
  }
}

export const DigitalHuman2D = ({
  className,
  avatarType = 'sparticle',
}: {
  className?: string;
  avatarType?: string;
}) => {
  const { id } = useParams();

  const urlList = {
    normal: 'https://cdn.jsdelivr.net/gh/mikeyang01/static_hosting@master/dev/anime_avatar.js',

    dnpAvatar: 'https://cdn.jsdelivr.net/gh/mikeyang01/static_hosting/dnp/anime_avatar.min.js',

    noCrossedArms: 'https://cdn.jsdelivr.net/gh/mikeyang01/static_hosting@master/no_crossed_arms/anime_avatar.min.js ',

    sparticle: 'https://static.yangth25.workers.dev/spa_yumi/local_anime.js',
  };

  useEffect(() => {
    // 5d82886e-a515-489e-a6ad-ad5099864a64/6e96a3a8-3a29-48dd-8ef0-d2bc6744863c 为 DNP 正式环境 bot id
    // 28b48307-4701-4cf1-872a-cdadbafa6361 为测试bot id
    const isDnpAvatar =
      id &&
      [
        '5d82886e-a515-489e-a6ad-ad5099864a64',
        '28b48307-4701-4cf1-872a-cdadbafa6361',
        '6e96a3a8-3a29-48dd-8ef0-d2bc6744863c',
      ].includes(id);
    const url = isDnpAvatar ? urlList.dnpAvatar : urlList[avatarType as keyof typeof urlList] || 'sparticle';
    loadDependencies(url).catch((error) => {
      console.error('Failed to load dependencies:', error);
    });

    return () => {
      const script = document.getElementById('avatar-anime-script');
      script?.remove();
      window.removeEventListener('avatarInitialized', () => {});
    };
  }, []);

  return <canvas id="canvas" className={className}></canvas>;
};
